
import React, {Component} from 'react'
import { Xhr } from 'hlp'



export default class DomainInp extends Component {

  inputRef = null
  domainPostfixRef = null
  baseDomainTxt = null

  state = {
    inFocus: false,
    descVisible: false,
    val: '',
    baseDomain: '',
    inputStyles: null,
    domainPostfixStyles: null
  }

  getInputRef = (el) => { this.inputRef = el }
  getDomainPostfix = (el) => { this.domainPostfixRef = el }
  getBaseDomainTxtRef = (el) => { this.baseDomainTxt = el }

  componentWillMount() {
    Xhr.loadJSON( '/constants.json' )
      .then( resp => {
        if ( resp.hasErr ) {
          console.log('resp: ', resp);
          return
        }
        this.setState( {
          baseDomain: resp.value.BASE_DOMAIN
        } )
      } )
  }

  handleFocus = () => {
    this.calcStyles()
    this.setState({inFocus: true})
  }

  handleBlur = () => {
    this.setState({
      inFocus: false,
      domainPostfixStyles: null,
      inputStyles: null,
    })
  }

  rememberVal = (ev) => {
    let val = ev.target.value

    this.setState({val})

    this.props.oninput()
  }

  calcStyles() {
    const inp = this.inputRef
    const postfix = this.domainPostfixRef
    const baseDomain = this.baseDomainTxt
    if ( !inp || !postfix || !baseDomain ) return
    const inpRect = inp.getBoundingClientRect()
    const postfixRect = postfix.getBoundingClientRect()
    const baseDomainRect = baseDomain.getBoundingClientRect()
    this.setState({
      domainPostfixStyles: {
        paddingLeft: inpRect.width - postfixRect.width,
      },
      inputStyles: {
        paddingRight: baseDomainRect.width
      }
    })
  }

  handleClickQuestion = (ev) => {
    ev.preventDefault()
    this.setState({descVisible: true})

    this.handleDocClickTmp = this.handleDocClick.bind(this)
    setTimeout(() => {
      document.addEventListener('click', this.handleDocClickTmp)
    }, 10)

  }

  handleDocClick(ev) {
    this.setState({descVisible: false})

    document.removeEventListener('click', this.handleDocClickTmp)
    this.handleDocClickTmp = null
  }

  render() {
    let txt = this.props.txt || ''
    let txtDesc = this.props.txtDesc || ''
    let wrpClass = 'platformNameWrp '

    const {domainPostfixStyles, inputStyles} = this.state

    wrpClass += this.props.errClass
    wrpClass += (this.state.inFocus || this.state.val !== '') ? 'inFocus ' : ''
    wrpClass += this.state.descVisible ? 'descVis ' : ''

    return (
      <label className={wrpClass}>
        <span>{txt}</span>
        <span className="error">{this.props.textErr}</span>
        <input
          ref={this.getInputRef}
          minLength={2}
          maxLength={30}
          name="platformName"
          type="text"
          value={this.state.val}
          data-type="domain"
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onInput={this.rememberVal}
          className={ this.props.className }
          style={inputStyles}
        />
        <span
          className="plholder"
          ref={this.getDomainPostfix}
          style={domainPostfixStyles}
        >
          <i>domain</i>
          <b ref={this.getBaseDomainTxtRef}>.{ this.state.baseDomain }</b>
        </span>

        <div className="question">
          <b onClick={this.handleClickQuestion}>?</b>

          <div className="domainDesc" ref="desc" dangerouslySetInnerHTML={{ __html: txtDesc }} />
        </div>

      </label>
    )
  }

}



// WEBPACK FOOTER //
// ./src/form/domain.jsx